import { useCustomParams } from "@/hooks/useCustomParams";
import { HorizontalFlex, Sorter } from "@enxcs/dap-ui-stratos";
import { useTranslation } from "react-i18next";
export interface SortingHeaderProps {
    index: number
    label: string
}

export function SortingHeader({ index, label }: SortingHeaderProps) {
    const { t } = useTranslation()

    const { onChangeSorting, sorting } = useCustomParams()

    return (
        <HorizontalFlex>
            <Sorter
                label={t(label)}
                columnIndex={index}
                sorting={sorting}
                onSort={onChangeSorting}
            />
        </HorizontalFlex>
    )
}